// @flow
import { resetPageReadiness } from '@redux/components/Page/actions';
import type { GlobalState } from '@globalTypes';

export default async (
  store: {
    subscribe: (callback: () => void) => void,
    dispatch: (action: { type: string }) => void,
    getState: () => GlobalState
  },
  timeout: number = 5000
): Promise<any> => {
  let unsubscribe: ?() => void;

  await Promise.race([
    new Promise((resolve: (value: any) => void): void => {
      unsubscribe = store.subscribe((): void => {
        if (store.getState().page.ready) resolve('yaay');
      });
    }),
    new Promise((resolve: (value: any) => void, reject: (value: any) => void): void => {
      setTimeout((): void => {
        reject(new Error('PAGE_READY action was never dispatched.'));
      }, timeout);
    })
  ]);

  if (unsubscribe) unsubscribe();

  store.dispatch(resetPageReadiness());
};
